import React from 'react'

import { RectangleSkeleton } from '@pb/components'

import styles from './ChallengeModalLoader.module.scss'

const ChallengeModalLoader: React.FC = () => {
  return (
    <div className={styles.challengeModalLoader}>
      <RectangleSkeleton className={styles.leftLogo} />
      <RectangleSkeleton className={styles.rightLogo} />
      <RectangleSkeleton className={styles.content} />
      <RectangleSkeleton className={styles.input} />
      <RectangleSkeleton className={styles.leftBtn} />
      <RectangleSkeleton className={styles.rightBtn} />
    </div>
  )
}

export default ChallengeModalLoader
